<mds-dialog dialogTitle="Submit Request">
    <mds-dialog-content>
        <div class="o-grid__row">
            <div class="o-grid__item">
                <mds-textarea
                    label="Additional Information"
                    placeholder="Type here..."
                    appearance="outline"
                    id="additionalInfo"
                    name="additionalInfo"
                    [autoSize]="true"
                    [cdkAutosizeMinRows]="8"
                    [cdkAutosizeMaxRows]="8"
                    [formCtrl]="additionalDetailsFormGroup.controls.additionalInfoControl"
                >
                </mds-textarea>
            </div>
        </div>
    </mds-dialog-content>
    <mds-dialog-actions [align]="'end'">
        <div class="flex flex-row gap-medpace">
            <mds-button [id]="'cancel-btn'" label="Cancel" (clickEvent)="closeDialog()" variant="outline"> </mds-button>
            <mds-button
                [id]="'confirm-btn'"
                label="Confirm"
                (clickEvent)="saveDialog()"
                [variant]="'filled'"
                [color]="'primary'"
            >
            </mds-button>
        </div>
    </mds-dialog-actions>
</mds-dialog>
